import styles from './skeletons.module.scss'

export default function DashboardCardSkeleton() {
  return (
    <div className={styles.dashboardCardSkeleton}>
      <div className={styles.cardHeader}>
        <div className={styles.textSkeleton}></div>
        <div className={styles.iconSkeleton}></div>
      </div>
      <div className={styles.cardContent}>
        <div className={styles.itemSkeleton}></div>
        <div className={styles.itemSkeleton}></div>
      </div>
    </div>
  )
}
import styles from './skeletons.module.scss'

export default function DashboardCardSkeleton() {
  return (
    <div className={styles.dashboardCardSkeleton}>
      <div className={styles.cardHeader}>
        <div className={styles.textSkeleton}></div>
        <div className={styles.iconSkeleton}></div>
      </div>
      <div className={styles.cardContent}>
        <div className={styles.itemSkeleton}></div>
        <div className={styles.itemSkeleton}></div>
      </div>
    </div>
  )
}
